import { render, staticRenderFns } from "./InterfaceTest.vue?vue&type=template&id=f1a68536&"
import script from "./InterfaceTest.vue?vue&type=script&lang=js&"
export * from "./InterfaceTest.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceTest.vue?vue&type=style&index=0&id=f1a68536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports